import parent from '@/store/interfaces/historicalGeneric'
const mystore = parent({ tipoEvento: 'impuestos', namespaced: true })

export default mystore
